import "./css/app.scss";
import Login from "./components/login";
import volteraWordmark from "./images/Voltera-wordmark-light.svg";

function App() {
  return (
    <main className='app'>
      <aside className='brand-panel'>
        <img className='voltera-wordmark' src={volteraWordmark} alt='Voltera' />
      </aside>

      <section className='login-section' aria-labelledby='login-title'>
        <div className='login'>
          <p className='login-eyebrow'>Voltera Partner Hub</p>
          <div className='brand-accent' aria-hidden='true' />
          <h1 id='login-title'>Welcome Back</h1>
          <p className='login-description'>
            Sign in with your partner account to continue.
          </p>
          <Login />
        </div>
      </section>
    </main>
  );
}

export default App;
